// extracted by mini-css-extract-plugin
export default {"container":"RelatedTrainingClassesList-module__container","relatedTrainingClasses":"RelatedTrainingClassesList-module__relatedTrainingClasses"};